import { render, staticRenderFns } from "./tempHum.vue?vue&type=template&id=51ff30c2"
import script from "./tempHum.vue?vue&type=script&lang=js"
export * from "./tempHum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports